<template>
    <div class="monthProgressReport-manage">
        <Paper class="monthProgressReport-manage-paper">
            <!-- <el-tabs class="monthProgressReport-list-tab-pane" v-model="activeTabs">
                <el-tab-pane label="月度进度表" name="theList" ref="myPane"> -->
                    <list-layout-paper>
                        <template slot="header-search" class="searchBox">
                            <search-box ref="searchBox" :search-key="config.name" :fields="config.searchFields"
                                :showResetBtn="true" @search-change="tableList.searchList" />
                        </template>
                        <template slot="header-button">
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="导入"
                                v-has="authorityCode.import"
                                @click="importOpera">
                                导入
                            </lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="导出"
                                :disabled="tableList.totalData.length === 0"
                                v-has="authorityCode.export"
                                @click="exportOpera">
                                导出
                            </lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="删除"
                                :disabled="selectedRows.length === 0"
                                v-has="authorityCode.delete"
                                @click="deleteOpera">
                                删除
                            </lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="刷新"
                                @click="refresh"
                                plain>
                                <span class="icon iconfont icon-refresh"></span>
                            </lotsButton>
                            <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                                <el-button
                                icon="iconfont icon-list_install"
                                type="primary"
                                size="mini"
                                :title="'列配置'"
                                @click="showColumnConfigDialog"
                                plain />
                            </el-tooltip>
                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <edit-table-box
                                ref="editTableBox"
                                key="attendanceRulesSettings"
                                v-loading="tableList.tableLoading"
                                :index="config.index"
                                :selection="config.selection"
                                :columns="config.columns"
                                :height="tableHeight"
                                :tableData="tableList.totalData"
                                :control="false"
                                :allowRowClick="false"
                                @btn-event="handleActive"
                                @selection-change="handleSelectionChange"
                            >
                                <template v-slot:col-append="{ item, row, rIndex }">
                                    <span v-if="['enableFlag'].includes(item.prop)">
                                        {{  dealFlagName(row[item.prop]) }}
                                    </span>
                                </template>
                            </edit-table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                :page-size.sync="tableList.pageSize"
                                @size-change="tableList.sizeChange"
                                :current-page.sync="tableList.pageNo"
                                @current-change="tableList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableList.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                <!-- </el-tab-pane>
            </el-tabs> -->
        </Paper>

        <!-- 表格列配置弹框 -->
        <column-config
            :pageID="config.name"
            :initColumns="config.columns"
            ref="otpColumnConfig"
            @header-change="config.columns = $event"
        />

        <!-- 导入弹窗 -->
        <addFileDialog
            ref="fileDialogRef"
            :config="importConfig"
            @uploadSuccessHandle="uploadSuccessHandle"
          >
        </addFileDialog>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import searchBox from '@/components/lots/searchBox';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getList, deleteApi, exportApi } from '@/modules/mdm/api/targetModdeules/monthProgressReport.js';
import { config as configStatic } from './config';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import { importConfigOpt } from './import';
import columnConfig from '@/components/lots/columnConfig/Index';
import _ from 'lodash';

export default {
    name: 'monthProgressReport',
    components: {
        Paper,
        searchBox,
        listLayoutPaper,
        lotsButton,
        editTableBox,
        lotsPagination,
        addFileDialog,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 按钮权限
        const authorityCode = reactive(btnAuthority.monthProgressReport);

        const config = reactive(configStatic);
        const otpColumnConfig = ref(null);
        // 列表列配置弹窗-打开
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };

        const activeTabs = ref('theList');

        class ListClass extends AdvanceListClass {
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            ...v
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }

        const tableList = new ListClass({
            Api: {
                listApi: getList // 查询接口
            },
            pageSize: 20
        });

        // 操作项
        const handleActive = (row, event) => {
            // 编辑
            // if (event === 'editOpera') {
            // }
            // 删除
            // if (event === 'delete') {
            // }
        };

        // 删除操作
        const deleteOpera = (row) => {
            const list = selectedRows.value.map(item => item.id);
            MessageBox.confirm('此操作将删除勾选中的数据,是否继续？', '温馨提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                tableList.tableLoading.value = true;
                deleteApi({ ids: list }).then(res => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                        tableList.getList();
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            });
        };

        const exportOpera = () => {
            const excelTitleList = config.columns?.filter(item => !item.hiddenColumn).map(item => ({
                name: item.label,
                property: item.prop
            })) ?? [];
            const { value } = tableList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            // 配置了那些字段就传那些
            newData.excelTitleList = excelTitleList;
            exportApi(newData).then(res => {
                if (+res.code === 0) {
                    Message.success('请稍后到右上角用户文件列表中下载');
                }
            });
        };

        const importConfig = ref({});
        // 打开导入弹窗
        const importOpera = () => {
            importConfig.value = importConfigOpt;
            setupContext.refs.fileDialogRef.openImport();
        };

        const uploadSuccessHandle = (data) => {
            console.log('uploadSuccessHandle', data);
            tableList.getList();
        };

        // 选择项
        const selectedRows = ref([]);
        const handleSelectionChange = (val) => {
            selectedRows.value = val;
        };

        const dealFlagName = (flag) => {
            if (flag === 1) {
                return '启用';
            } else if (flag === 0) {
                return '停用';
            } else {
                return '--';
            }
        };

        // 刷新列表
        const refresh = () => {
            tableList.getList();
        };

        onMounted(() => {
            tableList.getList();
        });

        return {
            tableList,
            config,
            handleActive,
            activeTabs,
            exportOpera,
            importOpera,
            deleteOpera,
            handleSelectionChange,
            authorityCode,
            importConfig,
            selectedRows,
            refresh,
            showColumnConfigDialog,
            otpColumnConfig,
            dealFlagName,
            uploadSuccessHandle
        };
    }
};
</script>

<style lang="less" >
.monthProgressReport-manage {
    width: 100%;

    .layout-content {
        box-shadow: none
    }

    .monthProgressReport-manage-paper {
        height: 100%;
    }

    .list-layout {
        padding-top: 20px;
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .monthProgressReport-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;

        &>.el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            &>.el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        .monthProgressReport-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.monthProgressReport-manage-paper {
        padding: 0px 20px 20px;

        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}
</style>
